class LocationSearch {
  constructor() {
    // Bind class methods
    this.handleClear = this.handleClear.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.init = this.init.bind(this);
    this.renderLocation = this.renderLocation.bind(this);

    document.addEventListener('DOMContentLoaded', this.init);
  }

  init() {
    // Bind DOM elements
    this.form = document.getElementById('location-search');
    this.container = document.querySelector('[data-ui="search-results"]');
    this.clearBtn = document.querySelector('[data-ui="search-clear"]');
    this.loadMoreBtn = document.querySelector('[data-ui="search-more"]');
    this.emptyMessage = document.querySelector('[data-ui="search-empty"]');

    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit);
      this.form.addEventListener('change', this.handleSubmit);
      this.clearBtn.addEventListener('click', this.handleClear);
      this.fetchData();
    }
  }

  async getAll(request) {
    const response = await request;

    if (!response._paging || !response._paging.next) {
      return response;
    }

    const all = await Promise.all([
      response,
      this.getAll(response._paging.next)
    ]);

    return [].concat(...all);
  }

  async fetchData() {
    const apiSettings = window.WP_API_Settings;

    if (!apiSettings) {
      return;
    }

    this.wp = new WPAPI({
      endpoint: apiSettings.root,
      nonce: apiSettings.nonce
    });

    this.registerRoutes();

    // Find region tag
    const [tag] = await this.wp.tags().param('slug', 'region');

    this.regionTag = tag || {};

    this.regions = await this.getAll(this.wp.regions());

    this.renderLocations();
  }

  registerRoutes() {
    this.wp.locations = this.wp.registerRoute('wp/v2', '/location/(?P<id>)', {
      // Listing any of these parameters will assign the built-in
      // chaining method that handles the parameter:
      params: [
        'before',
        'after',
        'author',
        'parent',
        'post',
        'filter',
        'tags_exclude'
      ]
    });

    this.wp.regions = this.wp.registerRoute('wp/v2', '/region/(?P<id>)', {
      // Listing any of these parameters will assign the built-in
      // chaining method that handles the parameter:
      params: [
        'before',
        'after',
        'author',
        'parent',
        'post',
        'filter',
        'tags_exclude'
      ]
    });
  }

  mapJoin(field, callback) {
    if (!field || !field.length) {
      return '';
    }

    return field.map(callback).join('');
  }

  renderLocation(post) {
    const { acf, content, link, title } = post;
    const companies = acf.location_company && acf.location_company.split(', ');
    const phoneNumbers =
      acf.location_phone_number && acf.location_phone_number.split(', ');
    const fields = {
      content: content.rendered,
      link: link,
      title: title.rendered,
      address: acf.location_address,
      companies: companies,
      phoneNumbers: phoneNumbers
    };

    return `
      <div class="acg-card acg-card--location">
        <div class="acg-card__content">
          <h3 class="acg-card__heading">${fields.title}</h3>
          ${this.mapJoin(
            fields.companies,
            company => `<p class="acg-card__desc">${company}</p>`
          )}
          <div class="acg-card__desc">${fields.address}</div>
          ${this.mapJoin(
            fields.phoneNumbers,
            phone =>
              `<p class="acg-card__desc acg-card__desc--phone">${phone}</p>`
          )}
        </div>
        ${fields.content &&
          `<a href="${link}" class="acg-card__btn acg-btn acg-btn--link">
          View <i class="acg-icon fas fa-chevron-right"></i>
        </a>`}
      </div>
      `;
  }

  renderResults(results, append = false) {
    const elements = results.map(this.renderLocation);
    const markup = elements.join('');

    this.toggleControls(results, markup);

    if (append) {
      this.container.insertAdjacentHTML('beforeend', markup);
    } else {
      this.container.innerHTML = markup;
    }
  }

  getValues(form) {
    return {
      name: form.elements[0].value,
      segment: form.elements[1].value,
      region: form.elements[2].value
    };
  }

  toggleControls(data, markup) {
    const callback = this.handleLoadMore.bind(this, data);

    if (data._paging && data._paging.next) {
      this.loadMoreBtn.onclick = callback;
      this.loadMoreBtn.style.cssText = 'display: block;';
    } else {
      this.loadMoreBtn.onclick = null;
      this.loadMoreBtn.style.cssText = '';
    }

    this.emptyMessage.style.cssText = markup ? '' : 'display: block;';
  }

  handleClear() {
    this.form.reset();
    this.clearBtn.style.cssText = '';

    this.renderLocations();
    this.form.elements[0].focus();
  }

  async handleLoadMore(data) {
    const request = await data._paging.next;

    this.renderResults(request, true);
  }

  async handleSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const values = this.getValues(form);
    const query = [
      {
        key: 'location_business_segment',
        value: values.segment
      }
    ];
    const selectedRegion = this.regions
      .filter(region => region.name === values.region)
      .map(region => region.id);

    const results = await this.wp
      .locations()
      .excludeTags(this.regionTag.id)
      .filter({ meta_query: query })
      .param('region', selectedRegion)
      .search(values.name)
      .order('asc')
      .orderby('title')
      .perPage(9);

    this.renderResults(results);
    this.clearBtn.style.cssText = 'display: inline-block;';
  }

  async renderLocations() {
    const results = await this.wp
      .locations()
      .excludeTags(this.regionTag.id)
      .order('asc')
      .orderby('title')
      .perPage(9);

    this.renderResults(results);
  }
}

export default LocationSearch;
